export default "__VITE_ASSET__CVUclkB2__"